<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Price Lists</v-toolbar-title>
        <v-spacer></v-spacer>

          <v-btn color="primary" text  :loading="loader" @click="verifyPriceLists">
          <v-icon left dark>mdi-import</v-icon>Verify Price Lists Rows
        </v-btn>

        <v-btn color="primary" text to="/import-price-lists">
          <v-icon left dark>mdi-import</v-icon> Import Price Lists
        </v-btn>
      </v-toolbar>
      
      <v-card-text>
        <v-row class="mt-1">
          <v-col cols="12" md="4">
            <v-btn color="accent" small to="/new-price-list">
              <v-icon left dark>mdi-plus</v-icon>New Price List
            </v-btn>
          </v-col>

          <!-- <v-col cols="12" md="4">
            <v-btn color="primary" text small :loading="loader" @click="verifyPriceLists">
              <v-icon left dark>mdi-check</v-icon> Verify Price List
            </v-btn>
          </v-col> -->

          <v-col cols="12" md="4">
            <v-btn class="float-right" color="primary" small text to="/copy-price-list">
              <v-icon left dark></v-icon>Copy Price List
            </v-btn>
          </v-col>

        </v-row>

        <v-row>
          <v-text-field name="priceListSearch" v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :items-per-page="pageItems" :headers="headers" :items="priceLists" :search="search">
              <!-- show template -->
              <template v-slot:item.showOnProductEdit="{ item }">{{ item.showOnProductEdit == true ? "Yes" : "No"
              }}</template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn color="editIcon" text :to="`/price-lists/${item.id}`" icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.viewAction="{ item }">
                <v-btn color="accent" text :to="`/price-lists/manage/${item.id}`">
                  <v-icon left>mdi-eye</v-icon> Manage Prices
                </v-btn>
              </template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.manage="{ item }">
                <v-btn color="accent" text :to="`/manage-price-list/${item.id}`">
                  <v-icon left>mdi-eye</v-icon> Manage All Prices
                </v-btn>
              </template>
              <!-- end -->


              <!-- excel template -->
              <template v-slot:item.importExcel="{ item }">
                <v-btn color="green" text :to="`/price-lists/import/${item.id}`">
                  <v-icon left>mdi-file-excel</v-icon> Import Price List
                </v-btn>
              </template>
              <!-- end -->

            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    loader: false,
    pageItems: 100,
    headers: [
      { text: "Price List", value: "Name" },
      { text: "Show On Product Edit", value: "showOnProductEdit" },
      { text: "Discount Percent", value: "discountPercent" },
      // { text: "Import Selling Prices", value: "importSellingPrices" },
      // { text: "Import Selling Prices", value: "importSellingPrices" },
      { text: "Manage", value: "manage" },
      { text: "Action", value: "action" }
    ],
    priceLists: []
  }),
  methods: {
    getData() {
      const self = this;
      this.$store
        .dispatch("get", `/price-list`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.priceLists = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    verifyPriceLists() {
      this.loader = true;
      const self = this;
      this.$store
        .dispatch("get", `/verify-price-lists`)
        .then(res => {
          if (res.ResultCode == 1200) {
            console.log('Price lists verified successfully.');
            this.$refs.snackbar.show('Price lists verified successfully', "green");
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.loader = false;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>